const pathName = window.location.pathname;
const pageName = document.title;
const eventProperties = (element) => {
  let label = element.textContent.trim();

  if (element.href?.startsWith('mailto:')) {
    label = 'CUSTOMER_EMAIL_ADDRESS';
  }

  if (element.href?.startsWith('tel:') || element.href?.startsWith('sms:')) {
    label = 'CUSTOMER_TELEPHONE_NUMBER';
  }

  return {
    label: label,
    element: element.id,
    path: pathName,
    page: pageName,
  };
};

document
  .querySelectorAll('a[id]')
  .forEach((element) =>
    window.analytics.trackLink(
      element,
      'Element Clicked',
      eventProperties(element)
    )
  );

document
  .querySelectorAll('button[id]')
  .forEach((element) =>
    window.analytics.trackClick(
      element,
      'Element Clicked',
      eventProperties(element)
    )
  );

document.addEventListener('OpportunitySpa:locationChanged', (evt) => {
  window.analytics.page({ referrer: evt.detail.referrer });
});

/**
 * Create an array of "clickable" feature events to track by event name. Since
 * the event names are namespaced and unique, they make good unique element IDs
 * also.
 */
['OpportunitySpa:OpportunitiesExporter:exporting'].forEach((eventName) => {
  document.addEventListener(eventName, () => {
    window.analytics.track('Element Clicked', {
      element: eventName,
      page: pageName,
      path: pathName,
    });
  });
});
